const mutationCache = {};

const merge = (original, mutation = {}) => {
    const { style: mutationStyle = {} } = mutation;

    return {
        ...original,
        ...mutation,
        style: { ...original.style, ...mutationStyle }
    };
};

const isMutated = ({ layerId, layers =[] }, mutations) => {
    const layerIds = [layerId, ...layers.map((layer) => layer.layerId)];

    return layerIds.some((id) => !!mutations[id]);
};

/**
 * Syncs a given variation into mutations cache, setting current variation as mutation source
 * @param {Variation} variation The variation to sync.
 */
const syncVariation = (variation) => {
    const entry = mutationCache[variation.id] || {};

    mutationCache[variation.id] = {
        source: variation,
        mutations: entry.mutations || {}
    };
};

/**
 * Observe callback to trigger upon mutation, Registers new mutations under existing entry
 * @param {String} variationId The variation id.
 * @param {String} layerId The layer id.
 * @param {Object} change The mutation.
 */
const observeMutation = (variationId, { layerId, ...change }) => {
    const entry = mutationCache[variationId];

    const current = entry.mutations[layerId] || {};
    mutationCache[variationId].mutations[layerId] = merge(current, change);
};

/**
 * Returns the current mutations registered for the requested variation
 * @param {String} id The variation Id
 * @returns {{ roots: Root[]}}
 */
const getMutations = (id) => {
    const entry = mutationCache[id];

    if (!entry) {
        throw new Error(`Could not get mutate variation from cache : ${id}, Are you sure you passed observeChanges={true} config ?`);
    }

    const { source, mutations } = entry;
    const { roots } = source;

    const mutateRoots = roots
        .filter((root) => isMutated(root, mutations))
        .map(({ layerId: rootLayerId, layers = [], ...root }) => {

            const mutatedLayers = layers.map(({ layerId, ...layer }) => merge({
                ...layer,
                layerId
            }, mutations[layerId]));

            return {
                ...merge({ ...root, layerId: rootLayerId }, mutations[rootLayerId]),
                layers: mutatedLayers
            };
        });

    return {
        roots: mutateRoots.reduce((roots, root) =>
            Object.assign(roots, { [root.layerId]: root }), {})
    };
};

export default { getMutations, syncVariation, observeMutation, __cache__: mutationCache };
